import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import Icon from 'components/common/Icon'
import { format } from 'd3-format'
import { dataStore } from '../../stores/UIStore'
import { withTranslation } from 'react-i18next'

const Summary = ({ uiStore, analysis, t }) => {
  const calculateGenderRatio = () => {
    if (analysis.female === 0) {
      return 0
    }

    return (analysis.male / analysis.female)
  }

  const calculateAverageAge = () => {
    if (analysis.sum === 0) return 0

    let sum = 0
    for (const i of analysis.pyramids.total.$mobx.values) {
      let age = null
      let averageAge = 0
      if (!i.age.includes('plus')) {
        age = i.age.split('_')
        averageAge = ((+age[0]) + (+age[1])) / 2
      } else {
        age = i.age.split('plus')
        averageAge = +age[0]
      }
      sum += (i.value * averageAge)
    }

    return (sum / analysis.sum)
  }
  return (
    <table
      className={classnames({
        summary: true,
        'summary-with-chart': uiStore.isBarChartActive,
        'summary-without-chart': !uiStore.isBarChartActive
      })}
    >
      <tbody style={{ verticalAlign: 'top' }}>
        <tr>
          <th className='number-population '>
            ({dataStore.defaultYear.result}) {t('POPULATION.POPULATION')}<Icon
              id='fa-question-circle-o'
              extraClasses={['number-population-icon']}
              onClick={() => {
                uiStore.openPopulationTooltip({
                  text: uiStore.population(),
                  selector: '.number-population '
                })
              }}
              onClickOutside={() => uiStore.hidePopulationTooltip()}
                                                                         />
          </th>
          <th className='number-income '>
            {t('POPULATION.AVERAGE_INCOME')} <Icon
              id='fa-question-circle-o'
              extraClasses={['number-income-icon']}
              onClick={() => {
                uiStore.openIncomeTooltip({
                  text: uiStore.houseHoldIncome(),
                  selector: '.number-income '
                })
              }}
              onClickOutside={() => uiStore.hideIncomeTooltip()}
                                             />
          </th>
          <th className='number-gender '>{t('POPULATION.GENDER_RATIO')}<Icon
            id='fa-question-circle-o'
            extraClasses={['number-gender-icon']}
            onClick={() => {
              uiStore.openGenderTooltip({
                text: uiStore.genderRatio(),
                selector: '.number-gender '
              })
            }}
            onClickOutside={() => uiStore.hideGenderTooltip()}
                                                                       />
          </th>
          <th>{t('POPULATION.AVERAGE_AGE')}</th>
          <th>{t('POPULATION.AREA')}</th>
          <th>{t('POPULATION.DENSITY')}</th>
        </tr>
        <tr>
          <td className='number'>{format(',.0f')(analysis.sum)}</td>
          {analysis.hh_size !== undefined && analysis.hh_size !== null && analysis.hh_size !== 0 && (dataStore.defaultYear.result >= 2020 && dataStore.defaultYear.result <= 2030)
            ? <td className='number'>{format(',.0f')(analysis.hh_size)}{''}</td>
            : <td className='number'><span>{t('GLOBAL.NA')}</span></td>}
          <td className='number'>{format(',.2f')(calculateGenderRatio())}</td>
          <td className='number'>{format(',.1f')(calculateAverageAge())}</td>
          <td className='number'>{format(',.1f')(analysis.area)}/<span>km<sup>2</sup></span></td>
          <td className='number'>{format(',.1f')(analysis.density)}/km</td>
        </tr>
      </tbody>
    </table>
  )
}
export default withTranslation()(inject('uiStore')(observer(Summary)))
